module.exports = __webpack_public_path__ + "img/bg1.23b04f73.png";